import AllVideosPage from "@components/videos/all-videos-page";
import { PageNewsLandingComp } from "@graphql/generated/page";
import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { loadTranslation } from "@lib/utils";
import { t } from "@lingui/macro";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  return {
    props: { translation },
  };
};

const Videos: PageNewsLandingComp = () => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale;
  const seoLocale = "/" + locale;
  const title = t`Videos - Lumi News`;
  const description = t`Watch daily highlights, reviews, exclusive interviews, LIVE coverage, and more videos by Malaysia's top publishers.`;

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: `https://luminews.my${
            seoLocale.includes("en") ? "" : seoLocale
          }${router.asPath}`,
          title: title,
          description: description,
        }}
      />

      <AllVideosPage />
    </>
  );
};

export default Videos;
